import EventsAndWinnersPage from './EventsAndWinnersPage';

export default EventsAndWinnersPage;
